/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DecideHttpRequest } from '../../models/decide-http-request';
import { DecideResponse } from '../../models/decide-response';

export interface CasesCaseIdStepsStepIdDecidePost$Params {
  caseId: string;
  stepId: string;
      body: DecideHttpRequest
}

export function casesCaseIdStepsStepIdDecidePost(http: HttpClient, rootUrl: string, params: CasesCaseIdStepsStepIdDecidePost$Params, context?: HttpContext): Observable<StrictHttpResponse<DecideResponse>> {
  const rb = new RequestBuilder(rootUrl, casesCaseIdStepsStepIdDecidePost.PATH, 'post');
  if (params) {
    rb.path('caseId', params.caseId, {});
    rb.path('stepId', params.stepId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DecideResponse>;
    })
  );
}

casesCaseIdStepsStepIdDecidePost.PATH = '/cases/{caseId}/steps/{stepId}/decide';
